import React from "react";
import { observable } from "mobx";
import { observer, inject } from "mobx-react";

import { Dialog, DialogContent, List, DialogActions, Button } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import { IValuesStore } from "Stores/Values/types";
import {
    STIconGrid,
    STListItem,
    STListIcon,
    STListItemIcon,
    STListItemText,
    STHelpIcon,
    STTitleTypography,
} from "./styles";
import { Values } from "@src/Tools/Values";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { Clear } from "@material-ui/icons";

interface IProps {
    management?: IManagementStore;
    values?: IValuesStore;
}

@inject("management", "values")
@observer
class AuthApplicationHelpModal extends React.Component<IProps> {
    @observable opened: boolean = false;

    handleOpen = () => {
        this.opened = true;
    };

    handleClose = () => {
        this.opened = false;
    };

    render() {
        const dialogContentArray = Values.getLocalizationValue("oAuthProvidersHelpModalText").split("-");
        const dialogHeder = dialogContentArray[0];
        dialogContentArray.shift();

        const { allowedHtmlTags } = this.props.values;

        return (
            <div>
                <STIconGrid onClick={this.handleOpen}>
                    <STHelpIcon />
                    {Values.getLocalizationValue("help")}
                </STIconGrid>
                <Dialog open={this.opened} onClose={this.handleClose}>
                    <DialogContent>
                        <STTitleTypography>{dialogHeder}</STTitleTypography>
                        <List>
                            {dialogContentArray.map((row, index) => (
                                <STListItem key={index}>
                                    <STListItemIcon>
                                        <STListIcon />
                                    </STListItemIcon>
                                    <STListItemText primary={parse(DOMPurify.sanitize(row, { ALLOWED_TAGS: allowedHtmlTags }))} />
                                </STListItem>
                            ))}
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} variant="contained">
                            <Clear />
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default AuthApplicationHelpModal;
